export default "__VITE_ASSET__5e138609__"